import { getPartnerId, PRODUCTS } from "@/helpers";
import $http, { buildQueryParamsFromList } from "@/helpers/http";
import Logger from "@/helpers/logger";

class BillingApi {
  getCurrentPlan(payload) {
    try {
      return $http.get("panel/billing/get-current-plan", { params: payload });
    } catch (e) {
      Logger.error("`getCurrentPlan` api", e);
      return Promise.reject(e);
    }
  }

  getAllPlans(currency) {
    try {
      const products = Object.values(PRODUCTS);
      const partnerId = getPartnerId();
      return $http.get(
        `panel/billing/get-all-set-plans?${buildQueryParamsFromList(
          products,
          "orderTypes"
        )}&partnerId=${partnerId}&currency=${currency}&includeHiddenFeatures=true`
      );
    } catch (e) {
      Logger.error("`getAllPlans` api", e);
      return Promise.reject(e);
    }
  }

  getAllAddons() {
    try {
      return $http.get("panel/billing/get-all-addons");
    } catch (e) {
      Logger.error("`getAllAddons` api", e);
      return Promise.reject(e);
    }
  }

  getCardDetails() {
    try {
      return $http.get("panel/billing/get-card-details");
    } catch (e) {
      Logger.error("`getCardDetails` api", e);
      return Promise.reject(e);
    }
  }

  deleteCards(payload) {
    try {
      return $http.post("panel/billing/delete-cards", payload);
    } catch (e) {
      Logger.error("`deleteCards` api", e);
      return Promise.reject(e);
    }
  }

  checkPaymentType(action) {
    try {
      return $http.post("panel/payment/initPayment", { action });
    } catch (e) {
      Logger.error("`checkPaymentType` api", e);
      return Promise.reject(e);
    }
  }

  calculateBundleCharges(requestPayload) {
    try {
      return $http.post("/bundle/purchase/calculate-charge", requestPayload);
    } catch (e) {
      Logger.error("`calculateBundleCharges` api", e);
      return Promise.reject(e);
    }
  }

  renewPlan(requestPayload) {
    try {
      return $http.post("/panel/billing/update-config", requestPayload);
    } catch (e) {
      Logger.error("`updateConfig - renewPlan` api", e);
      return Promise.reject(e);
    }
  }

  changeBillingCycle(requestPayload) {
    try {
      return $http.post("/panel/billing/update-config", requestPayload);
    } catch (e) {
      Logger.error("`updateConfig - changeBillingCycle` api", e);
      return Promise.reject(e);
    }
  }

  getAddCardIntent() {
    try {
      return $http.post("panel/billing/init-add-card");
    } catch (e) {
      Logger.error("`getAddCardIntent` api", e);
      return Promise.reject(e);
    }
  }

  changeBillingDate(requestPayload) {
    try {
      return $http.post("/panel/billing/update-config", requestPayload);
    } catch (e) {
      Logger.error("`changeBillingDate` api", e);
      return Promise.reject(e);
    }
  }

  getTaxDetails() {
    try {
      return $http.get("/internal/get-tax-details");
    } catch (e) {
      Logger.error("`getTaxDetails` api", e);
      return Promise.reject(e);
    }
  }

  getBillingAddress() {
    try {
      return $http.get("/panel/billing/get-billing-address");
    } catch (e) {
      Logger.error("`getTaxDetails` api", e);
      return Promise.reject(e);
    }
  }

  setBillingAddress(payload) {
    try {
      return $http.post("panel/billing/set-billing-address", payload);
    } catch (e) {
      Logger.error("`setBillingAddress` api", e);
      return Promise.reject(e);
    }
  }

  updateAddonConfig(payload) {
    try {
      return $http.post("/panel/billing/update-addon-config", payload);
    } catch (e) {
      Logger.error("`updateAddonConfig` api", e);
      return Promise.reject(e);
    }
  }

  getAllPricingConfigs() {
    try {
      return $http.get("/panel/billing/get-all-pricing-configs");
    } catch (e) {
      Logger.error("`getAllPricingConfigs` api", e);
      return Promise.reject(e);
    }
  }

  initBundlePayment(requestPayload) {
    try {
      return $http.post("/bundle/purchase/init", requestPayload);
    } catch (e) {
      Logger.error("`initBundlePayment` api", e);
      return Promise.reject(e);
    }
  }

  completeBundlePayment(requestPayload) {
    try {
      return $http.post("/bundle/purchase/complete", requestPayload);
    } catch (e) {
      Logger.error("`completeBundlePayment` api", e);
      return Promise.reject(e);
    }
  }
}

const billingApi = new BillingApi();

export default billingApi;
